'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

exports.default = reducer;
exports.requestPermission = requestPermission;

var _firebase = require('firebase');

var firebase = _interopRequireWildcard(_firebase);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var REQUEST_PERMISSION = 'redux-frontend/push/REQUEST_PERMISSION';
var REQUEST_PERMISSION_SUCCESS = 'redux-frontend/push/REQUEST_PERMISSION_SUCCESS';
var REQUEST_PERMISSION_FAIL = 'redux-frontend/push/REQUEST_PERMISSION_FAIL';

var initialState = {};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    default:
      return state;
  }
}

function requestPermission() {
  return {
    types: [REQUEST_PERMISSION, REQUEST_PERMISSION_SUCCESS, REQUEST_PERMISSION_FAIL],
    promise: function promise(client) {
      if (!('Notification' in window)) {
        return _promise2.default.reject('Notification not supported');
      }
      var messaging = firebase.messaging();
      return messaging.requestPermission().then(function () {
        return messaging.getToken();
      }).then(function (token) {
        return client.post('/session/push', {
          data: {
            platform: 'web',
            token: token
          }
        });
      });
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/push.js
// module id = 325
// module chunks = 47